import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { Unit } from 'src/features/units/utils/types';

const RESOURCE = '/financial-documents/unit/:unitId/';

type QueryFnType = typeof queryFn;

interface DTO {
    unitId: string;
}
const queryFn = ({ unitId }: DTO): Promise<Unit> => {
    return axios.get(formatResourcePath(RESOURCE, { unitId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetUnit, RESOURCE as UNIT_RESOURCE };
